
































































































import Vue from 'vue';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';
const Ripple = require('vue-ripple-directive');
import { export_array_to_excel } from '../libs/excel';
import moment from 'moment';
import axios from 'axios';
import _ from 'lodash';

export default Vue.extend({
  components: {
    DatePicker,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    const range = [moment().subtract(1, 'days').valueOf(), moment().valueOf()];
    return {
      display: false,
      alarmLevels: [
        { id: 1, txt: '資訊' },
        { id: 2, txt: '警告' },
        { id: 3, txt: '嚴重' },
      ],
      columns: [
        {
          key: 'time',
          label: '時間',
          sortable: true,
        },
        {
          key: 'level',
          label: '等級',
          sortable: true,
          formatter: (value: number) => {
            switch (value) {
              case 1:
                return '資訊';
              case 2:
                return '警告';
              case 3:
                return '嚴重';
              default:
                return '未知';
            }
          },
        },
        {
          key: 'subSrc',
          label: '來源',
          sortable: true,
        },
        {
          key: 'desc',
          label: '詳細資訊',
          sortable: true,
        },
      ],
      eventSrc:[
        { id: '攝影機', txt: '攝影機' },
        { id: '測值', txt: '感測器' },
      ],
      rows: Array<any>(),
      form: {
        range,
        alarmLevel: 1,
        src: '攝影機',
      },
    };
  },
  methods: {
    async query() {
      try{
        this.display = true;
        const url = `/AlarmReport/${this.form.alarmLevel}/${this.form.range[0]}/${this.form.range[1]}`;
        const res = await axios.get(url);
        if(res.status !== 200)
          return;

        const ret = Array<any>();
        for (const alarm of res.data) {
          alarm.time = moment(alarm.time).format('lll');
          const src = alarm.src.split(':');
          alarm.src = src[1];
          if(alarm.subSrc && alarm.subSrc.indexOf(this.form.src) !== -1)
            ret.push(alarm);
        }

        this.rows = ret;
      }catch(e){
        console.error(e);
      }
    },
    exportExcel() {
      const title = this.columns.map(e => e.label);
      const key = this.columns.map(e => e.key);
      const data = Array<any>();
      for (let entry of this.rows) {
        let e: any = Object.assign({}, entry);
        for (let column of this.columns) {
          let k = column.key;
          if (column.formatter) {
            e[k] = column.formatter(_.get(entry, k));
          } else e[k] = _.get(entry, k);
        }
        data.push(e);
      }
      const start = new Date(this.form.range[0]);
      start.toLocaleDateString();
      let month = String(start.getMonth() + 1).padStart(2, '0');
      let day = String(start.getDate()).padStart(2, '0');
      const end = new Date(this.form.range[1]);
      let monthEnd = String(end.getMonth() + 1).padStart(2, '0');
      let dayEnd = String(end.getDate()).padStart(2, '0');
      const params = {
        title,
        key,
        data,
        autoWidth: true,
        filename: `${start.getFullYear()}${month}${day}_${monthEnd}${dayEnd}警報報表.xlsx`,
      };
      export_array_to_excel(params);
    },
  },
});
